module.exports = __webpack_public_path__ + "static/media/2.c64405b7.svg";